import { render, staticRenderFns } from "./tenantList.vue?vue&type=template&id=21d4ec32&scoped=true"
import script from "./tenantList.vue?vue&type=script&lang=js"
export * from "./tenantList.vue?vue&type=script&lang=js"
import style0 from "./tenantList.vue?vue&type=style&index=0&id=21d4ec32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d4ec32",
  null
  
)

export default component.exports